import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.formDialog,
      callback: function ($$v) {
        _vm.formDialog = $$v;
      },
      expression: "formDialog"
    }
  }, [_vm.formDialog ? _c('niota-classic-devices-edit-form', {
    attrs: {
      "editedItem": _vm.editedItem,
      "deviceTypes": _vm.deviceTypes,
      "applications": _vm.applications,
      "datasourceType": _vm.datasourceType
    },
    on: {
      "close": _vm.closeForm,
      "refreshList": _vm.refreshList
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.addNew,
      callback: function ($$v) {
        _vm.addNew = $$v;
      },
      expression: "addNew"
    }
  }, [_vm.addNew ? _c('niota-classic-devices-add-add-new', {
    attrs: {
      "editedItem": _vm.editedItem,
      "deviceTypes": _vm.deviceTypes,
      "datasourceType": _vm.datasourceType
    },
    on: {
      "close": function ($event) {
        _vm.addNew = false;
      },
      "refreshList": _vm.refreshList,
      "reset-originator": _vm.resetOriginator
    }
  }) : _vm._e()], 1), _c('div', {
    attrs: {
      "max-width": "900"
    }
  }, [_vm.firstStep ? _c('niota-classic-devices-add-item-selector', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.firstStepSelectApplication'),
      "editedItem": _vm.editedItem,
      "type": 'application',
      "plainAccounts": _vm.accounts
    },
    on: {
      "close": function ($event) {
        _vm.firstStep = false;
      },
      "item-selected": _vm.selectedApplication
    }
  }) : _vm._e()], 1), _c('div', {
    attrs: {
      "max-width": "900"
    }
  }, [_vm.secondStep ? _c('niota-classic-devices-add-item-selector', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.secondStepSelectOriginator'),
      "editedItem": _vm.editedItem,
      "type": 'originator',
      "plainAccounts": _vm.accounts
    },
    on: {
      "close": function ($event) {
        _vm.secondStep = false;
      },
      "item-selected": _vm.selectedOriginator,
      "reset-application": _vm.resetApplication
    }
  }) : _vm._e()], 1), _c('div', {
    attrs: {
      "max-width": "900"
    }
  }, [_vm.thirdStep ? _c('niota-classic-devices-add-add', {
    attrs: {
      "item": _vm.editedItem,
      "originator": _vm.originator,
      "applicationId": _vm.editedItem.applicationId,
      "deviceTypes": _vm.deviceTypes,
      "datasourceType": _vm.datasourceType
    },
    on: {
      "close": function ($event) {
        _vm.thirdStep = false;
      },
      "addNewItem": function ($event) {
        _vm.thirdStep = false;
        _vm.addNew = true;
      },
      "reset-originator": _vm.resetOriginator,
      "refreshList": _vm.refreshList
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.editAllFormDialog,
      callback: function ($$v) {
        _vm.editAllFormDialog = $$v;
      },
      expression: "editAllFormDialog"
    }
  }, [_vm.editAllFormDialog ? _c('niota-classic-devices-multiple-edit-form', {
    attrs: {
      "editAllFormDialog": _vm.editAllFormDialog,
      "selectedRows": _vm.selectedRows,
      "deviceTypes": _vm.deviceTypes,
      "applications": _vm.applications
    },
    on: {
      "close": _vm.closeEditAllForm,
      "refreshList": _vm.refreshList
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.qrScanner,
      callback: function ($$v) {
        _vm.qrScanner = $$v;
      },
      expression: "qrScanner"
    }
  }, [_vm.qrScanner ? _c('niota-classic-devices-qr-form', {
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.deviceQrIdentification')
    },
    on: {
      "close": function ($event) {
        _vm.qrScanner = false;
      }
    }
  }) : _vm._e()], 1), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('NiotaClassic.Devices.title'),
      "subtitle": _vm.$i18n_t('NiotaClassic.Devices.form.deviceSubTitle')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-barcode-read",
            "title": _vm.$i18n_t('NiotaClassic.Devices.form.qrScanner'),
            "disabled": !_vm.isIotHubManager
          },
          on: {
            "click": function ($event) {
              _vm.qrScanner = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-layer-plus",
            "title": _vm.$i18n_t('NiotaClassic.Devices.form.csvUpload'),
            "disabled": !_vm.isIotHubManager
          },
          on: {
            "click": _vm.csvUpload
          }
        }), _c('niota-classic-common-account-filter', {
          attrs: {
            "iconOnly": _vm.isMobile,
            "initiallySelected": _vm.getAccountsIdsFromQueryParams(),
            "multiple": "",
            "n1Accounts": ""
          },
          on: {
            "selected": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "reset-filter": _vm.resetFilter,
            "accounts-loaded": () => {
              _vm.isLoadingAccounts = false;
            }
          }
        }), _vm.isMobile ? _c('span', [_vm.selectedRows.length ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-edit",
            "title": _vm.$i18n_t('NiotaClassic.Devices.editAll'),
            "disabled": !_vm.isIotHubManager
          },
          on: {
            "click": function ($event) {
              return _vm.editAll();
            }
          }
        }) : _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-plus",
            "title": _vm.$i18n_t('Common.create'),
            "disabled": !_vm.isIotHubManager
          },
          on: {
            "click": function ($event) {
              return _vm.addDevice();
            }
          }
        })], 1) : _c('span', [_vm.selectedRows.length ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-edit",
            "disabled": !_vm.isIotHubManager
          },
          on: {
            "click": function ($event) {
              return _vm.editAll();
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.editAll')) + "\n        ")]) : _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-plus",
            "disabled": !_vm.isIotHubManager
          },
          on: {
            "click": function ($event) {
              return _vm.addDevice();
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.create')) + "\n        ")])], 1)];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": null
    }
  }, [!_vm.isLoadingAccounts ? _c('niota-classic-devices-lists-list', {
    ref: "list",
    attrs: {
      "selectedAccounts": _vm.selectedAccounts
    },
    on: {
      "edit-item": _vm.editDevice,
      "enterSelect": _vm.getSelectedRows
    }
  }) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };